import React, { useEffect, useState } from "react";
import { Row, Col, Form, Stack, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import notificationImage from "../../../Assets/images/Background.png";
import msgIcon from "../../../Assets/images/message_ic.png";
import "./EditNotification.css";
import { roles } from "../../../utils/helperFunction";
import {
  RegisterEditNotification,
  getMessageDetails,
  updateMsgNotification,
} from "../../../redux/slice/MessageCentreSlice";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

function EditNotification() {
  const currentDate = dayjs();
  const [locations, setLocations] = useState([]);
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { role } = useSelector((state) => state.AUTH);
  const { rm_super_admin } = roles;
  const [apiLoading, setApiLoading] = useState(false);

  const [notificationData, setNotificationData] = useState({
    title: "",
    message: "",
    send_message_to: [],
    location: "United Kingdom",
    industry: "",
  });

  const [publishDetails, setPublishDetails] = useState({
    revisions: 0,
    publish_on: currentDate,
    category: "",
    status: "pending",
  });
  const location = useLocation();
  const statusOption = [
    { label: "Draft", value: "cancelled" },
    ...(role !== rm_super_admin
      ? [{ label: "Pending Approval", value: "pending" }]
      : []),
    { label: "Approved", value: "approved" },
    { label: "Scheduled", value: "scheduled" },
    { label: "Published", value: "completed" },
  ];

  useEffect(() => {
    if (location.state) {
      setLoading(true);
      const data = {
        id: location.state.id,
      };
      dispatch(getMessageDetails(data)).then(({ payload }) => {
        setLoading(false);
        if (payload?.status === 200) {
          const { data } = payload;
          setNotificationData((prev) => {
            return {
              ...prev,
              title: data?.title ?? "",
              message: data?.message ?? "",
              send_message_to: data?.send_message_to ?? "",
              location: data?.location ?? "",
              industry: data?.industry ?? "",
            };
          });
          setPublishDetails((prev) => {
            return {
              ...prev,
              status: data?.status ?? "",
              revision: data?.revision ?? "",
              publish_on: data?.publish_on ?? "",
              category: data?.category?.toLowerCase() ?? "",
              revisions: data?.revisions ?? 0,
            };
          });
        }
      });
    }
  }, [location]);

  const handleSave = () => {
    const validationErrors = {};

    // Validate title
    if (!notificationData.title.trim()) {
      validationErrors.title = "*Title is required";
    }

    // Validate message
    if (!notificationData.message.trim()) {
      validationErrors.message = "*Message is required";
    }

    // Validate send_message_to
    if (notificationData.send_message_to.length === 0) {
      validationErrors.send_message_to =
        "*Please select at least one recipient";
    }

    // Validate location
    if (!notificationData.location) {
      validationErrors.location = "*Location is required";
    }

    // Validate industry
    if (!notificationData.industry) {
      validationErrors.industry = "*Industry is required";
    }

    // Validate status
    if (!publishDetails.status) {
      validationErrors.status = "*Status is required";
    }

    // Validate publish_on
    if (
      !publishDetails.publish_on ||
      !dayjs(publishDetails.publish_on).isValid()
    ) {
      validationErrors.publish_on = "*Publish date is required";
    }

    // Validate category
    if (!publishDetails.category) {
      validationErrors.category = "*Category is required";
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setApiLoading(true);
    dispatch(
      RegisterEditNotification({ ...notificationData, ...publishDetails })
    )
      .then((response) => {
        if (response.payload && response.payload.status === 200) {
          navigate("/messaging"); // Redirect to "/messaging" after successful save
        }
      })
      .catch((error) => {
        console.error("Error updating article:", error);
      })
      .finally(() => {
        setApiLoading(false);
      });
  };

  const onCancelHandler = () => {
    navigate("/messaging");
  };

  const handlePublishDetailsChange = (fieldName, value) => {
    setPublishDetails((prevDetails) => ({
      ...prevDetails,
      [fieldName]: value && dayjs(value).isValid() ? value.toISOString() : "",
    }));
  };

  const handleChange = (fieldName, value) => {
    setPublishDetails((prevDetails) => ({
      ...prevDetails,
      [fieldName]: value,
    }));
  };

  const handleTitleChange = (e) => {
    setNotificationData((prevData) => ({
      ...prevData,
      title: e.target.value,
    }));
  };

  const industries = [
    "All",
    "Agriculture, forestry & fishing",
    "Mining & quarrying",
    "Manufacturing",
    "Electricity, gas, steam & air conditioning supply",
    "Water supply, sewerage, waste & remediation activities",
    "Construction",
    "Wholesale & retail trade; repair of motor vehicles and motorcycles",
    "Transport & storage",
    "Accommodation & food service activities",
    "Information & communication",
    "Financial & insurance activities",
    "Real estate activities",
    "Professional scientific & technical activities",
    "Administrative & support service activities",
    "Public admin & defence; compulsory social security",
    "Education",
    "Human health & social work activities",
    "Arts, entertainment & recreation",
    "Other service activities",
    "Private households",
  ];

  const checkboxes = [
    {
      title: "Tell Arnie Mobile App",
      checkboxes: [
        { value: "general_users", label: "All Users" },
        { value: "user_admin", label: "User Admin" },
        { value: "user_super_admin", label: "Super Admins" },
      ],
      col: 4,
    },
    {
      title: "Tell Arnie Registered Distributors",
      checkboxes: [
        { value: "general_distributors", label: "Sales Person" },
        { value: "distributor_admin", label: "Admin" },
        { value: "distributor_super_admin", label: "Super Admin" },
      ],
      col: 4,
    },
    {
      title: "Reliance Medical",
      checkboxes: [
        { value: "rm_local_team", label: "Local Terms" },
        { value: "rm_global_team", label: "Global Organisation" },
      ],
      col: 6,
    },
  ];

  useEffect(() => {
    // Simulated data source with location mappings
    const locationData = [
      { id: 1, name: "All" },
      { id: 2, name: "United Kingdom" },
      // { id: 2, name: "Country 2" },
      // Add more location entries as needed
    ];
    setLocations(locationData);
  }, []);

  const handleMessageChange = (e) => {
    setNotificationData((prevData) => ({
      ...prevData,
      message: e.target.value,
    }));
  };

  const handleCheckboxChange = (label) => {
    // Toggle checkbox state
    const updatedCheckboxState = [...notificationData.send_message_to];
    if (updatedCheckboxState.includes(label)) {
      updatedCheckboxState.splice(updatedCheckboxState.indexOf(label), 1);
    } else {
      updatedCheckboxState.push(label);
    }
    // Update notificationData state
    setNotificationData((prevData) => ({
      ...prevData,
      send_message_to: updatedCheckboxState,
    }));
  };

  const handleLocationChange = (e) => {
    setNotificationData((prevData) => ({
      ...prevData,
      location: e.target.value,
    }));
  };

  const handleIndustryChange = (e) => {
    setNotificationData((prevData) => ({
      ...prevData,
      industry: e.target.value,
    }));
  };

  const onUpdateHandler = async () => {
    const data = {
      title: notificationData.title,
      message: notificationData.message,
      send_message_to: notificationData.send_message_to,
      location: notificationData.location,
      industry: notificationData.industry,
      status: publishDetails.status,
      revisions: publishDetails.revisions,
      publish_on: publishDetails.publish_on,
      category: publishDetails.category,
      id: location.state.id,
    };
    try {
      setApiLoading(true);
      const { payload } = await dispatch(updateMsgNotification(data));
      if (payload?.status === 200) {
        navigate("/messaging");
      }
    } catch (error) {
      console.error("Error in updating message notification:", error);
    } finally {
      setApiLoading(false);
    }
  };

  const categoryOptions = [
    { label: "How To Video", value: "how to video" },
    { label: "Product Update", value: "product update" },
    {
      label: "Legislation and Compliance",
      value: "legislation and compliance",
    },
    { label: "News Update", value: "news update" },
    { label: "Product Launches", value: "product launches" },
    { label: "Training", value: "training" },
    { label: "user Define", value: "user define" },
  ];

  if (loading) {
    return <Loader />;
  }

  return (
    <Row className="row-gap-4 flex-fill align-items-start align-items-lg-center">
      <Col lg={4} xl={3}>
        <div className="notification-card d-flex justify-content-center">
          {/* Image representing the phone screen */}
          <div className="position-relative d-inline-flex">
            <img
              src={notificationImage}
              className="img-fluid"
              alt={notificationData.title}
            />
            <div className="notification_msg gap-2">
              <div className="head_msg gap-2 flex-wrap">
                <div className="d-flex gap-2 align-items-center">
                  <img src={msgIcon} alt="" />
                  <span
                    className="fw-500"
                    style={{ fontSize: "12px", letterSpacing: "1px" }}
                  >
                    TELL ARNIE
                  </span>
                </div>
              </div>
              <h6
                className="m-0 text-white fw-bold"
                style={{ fontSize: "14px", letterSpacing: "0.8px" }}
              >
                {notificationData.title}
              </h6>
              {/* Display notification title */}
              <h6
                className="m-0 text-white fw-normal"
                style={{ fontSize: "14px", letterSpacing: "0.8px" }}
              >
                {notificationData.message}
              </h6>
              {/* Display notification message */}
            </div>
          </div>
        </div>
      </Col>
      <Col md={6} lg={4} xl={5} className="h-100">
        <div className="notification-card card border-0 h-100 popup-layout">
          <div
            className="position-sticky bg-white header-section"
            style={{ zIndex: 1002 }}
          >
            <h4 className="text-center fw-bold m-0">
              {location?.state ? "Edit" : "Create"} Notification
            </h4>
            <hr className="my-3 my-md-4" />
          </div>
          <div className="title-box mb-2">
            <div className="d-flex justify-content-between pb-2">
              <p className="mb-0">Title</p>
              <span>{notificationData.title.length}/100</span>
            </div>
            <input
              className="input_style"
              name="title"
              type="text"
              placeholder="Title"
              maxLength={100}
              value={notificationData.title}
              onChange={handleTitleChange}
            />
            {errors.title && (
              <p className="text-danger mt-1 mb-0">{errors.title}</p>
            )}
          </div>
          <div className="message-box mb-2">
            <div className="d-flex justify-content-between pb-2">
              <p className="mb-0">Message</p>
              <span>{notificationData.message.length}/100</span>
            </div>
            <textarea
              className="textarea_style"
              name="message"
              cols={3}
              placeholder="Message"
              maxLength={100}
              value={notificationData.message}
              onChange={handleMessageChange}
            ></textarea>
            {errors.message && (
              <p className="text-danger mt-1 mb-0">{errors.message}</p>
            )}
          </div>
          <div className="checkboxes border-top border-bottom py-3 my-3">
            <h6 className="fw-bold mb-3">Send To</h6>
            {checkboxes.map((option, index) => (
              <div key={index}>
                <p className="m-0">{option.title}</p>
                <hr className="my-2" />
                <Form.Group as={Row}>
                  {option.checkboxes.map((checkbox, index) => (
                    <Col key={index} md={option.col}>
                      <Form.Check
                        id={`checkbox-${checkbox.label}`}
                        type="checkbox"
                        name="send_message_to"
                        label={checkbox.label}
                        checked={notificationData.send_message_to.includes(
                          checkbox.value
                        )}
                        onChange={() => handleCheckboxChange(checkbox.value)}
                      />
                    </Col>
                  ))}
                </Form.Group>
              </div>
            ))}
            {errors.send_message_to && (
              <p className="text-danger mt-1 mb-0">{errors.send_message_to}</p>
            )}
          </div>

          <div className="select_wrapper mb-3 mt-3">
            {/* Location select */}
            <label htmlFor="">Location(s):</label>
            <select
              value={notificationData.location}
              onChange={handleLocationChange}
              name="location"
            >
              <option>Choose Location</option>
              {locations.map((location) => (
                <option key={location.id} value={location.name}>
                  {location.name}
                </option>
              ))}
            </select>
          </div>
          {errors.location && (
            <p className="text-danger mt-1 mb-0">{errors.location}</p>
          )}
          <div className="mb-3 mt-4">
            <div className="select_wrapper">
              {/* Industry select */}
              <label htmlFor="">Industry(s)</label>
              <select
                value={notificationData.industry}
                onChange={handleIndustryChange}
                name="industry"
              >
                <option>Choose Industry</option>
                {industries.map((industry, index) => (
                  <option key={index} value={industry}>
                    {industry}
                  </option>
                ))}
              </select>
            </div>
            {errors.industry && (
              <p className="text-danger mt-1 mb-0">{errors.industry}</p>
            )}
          </div>
        </div>
      </Col>
      <Col md={6} lg={4} xl={4} className="h-100">
        <div className="notification-card card border-0 h-100 popup-layout">
          <Stack>
            <div
              className="position-sticky bg-white header-section"
              style={{ zIndex: 1002 }}
            >
              <h4 className="text-center fw-bold m-0">Publish Details</h4>
              <hr className="my-3 my-md-4" />
            </div>
            <div className="select_wrapper mb-3">
              <label>Status:</label>
              <select
                value={publishDetails.status}
                onChange={(e) => handleChange("status", e.target.value)}
                name="status"
                disabled={role !== rm_super_admin ? true : false}
              >
                <option value="" disabled selected className="option-title">
                  Choose Status{" "}
                </option>
                {statusOption.map((option, key) => {
                  return (
                    <option key={key} value={option.value}>
                      {option.label}
                    </option>
                  );
                })}
              </select>
            </div>
            {errors.status && (
              <p className="text-danger mt-1 mb-0">{errors.status}</p>
            )}
            <div className="revision mb-3">
              <p>Revisions: {publishDetails.revisions}</p>
            </div>
            <div className="border-bottom mb-3 pb-3">
              <div className="d-flex gap-2 align-items-center">
                <label htmlFor="" className="text-nowrap">
                  Publish on:{" "}
                </label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    value={
                      publishDetails.publish_on
                        ? dayjs(publishDetails.publish_on)
                        : null
                    }
                    onChange={(date) =>
                      handlePublishDetailsChange("publish_on", date)
                    }
                    minDate={currentDate}
                    name="publish_on"
                    format="DD-MM-YYYY HH:mm"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              {errors.publish_on && (
                <p className="text-danger mt-1 mb-0">{errors.publish_on}</p>
              )}
            </div>
            <div className="select_wrapper mb-3 border-bottom pb-3">
              <label htmlFor="">Category:</label>
              <select
                value={publishDetails.category}
                onChange={(e) => handleChange("category", e.target.value)}
                name="category"
              >
                <option value="" disabled selected className="option-title">
                  Choose Category
                </option>
                {categoryOptions.map(({ label, value }, index) => (
                  <option key={index} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            {errors.category && (
              <p className="text-danger mt-1 mb-0">{errors.category}</p>
            )}
            {/* <div className="select_wrapper my-3">
              <b>
                Restrict notifications to users who have registered the
                following products
              </b>
            </div>
            <div className="search_btn_add mb-3 border-bottom pb-3">
              <Form inline>
                <FormControl
                  type="text"
                  placeholder="Search"
                  className="mr-sm-2"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <CustomButton variant="primary" onClick={handleAddClick}>
                  Add
                </CustomButton>
              </Form>
            </div>
            {nameData.length > 0 && (
              <div className="d-flex gap-3 flex-wrap">
                {nameData.map((curElm, index) => (
                  <div className="position-relative" key={index}>
                    <button
                      className={`w-100 border btn font-14-class ${
                        manageButton === index + 1
                          ? "border-primary text-primary"
                          : "text-black-50"
                      }`}
                      style={{ whiteSpace: "normal" }}
                      type="button"
                      onClick={() => setManageButton(index + 1)}
                    >
                      {curElm.product_name}
                    </button>
                    {manageButton === index + 1 && (
                      <span
                        className={`close-button-span ${
                          manageButton === index + 1 ? "text-primary" : ""
                        }`}
                      >
                        <IoIosCloseCircleOutline
                          className="cursor text_gray"
                          onClick={() => removeGroup(curElm._id)}
                          size={25}
                        />
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )} */}
          </Stack>
          <div className="position-sticky bg-white footer-section d-flex gap-3 justify-content-end flex-wrap-reverse">
            <Button
              onClick={onCancelHandler}
              className="btn-dark flex-grow-1 flex-sm-grow-0"
              disabled={apiLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={location.state ? onUpdateHandler : handleSave}
              className="flex-grow-1 flex-sm-grow-0"
              disabled={apiLoading}
            >
              {apiLoading ? (
                <ButtonLoader />
              ) : (
                `${location.state ? "Update" : "Save"} Changes`
              )}
            </Button>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default EditNotification;
